export default {
  'Reviews.title': 'Отзывы',
  'Reviews.search': 'Поиск',
  'Reviews.noData': 'Вы не добавили ни одного продукта',
}
